import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { notification } from "antd";

const GenericTitle = "Unexpected Error";
const GenericText = "An unexpected error occurred. Please try again later or contact Autosled support for assistance.";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60000, // 1 Minute
      retry: false,
    },
  },
  queryCache: new QueryCache({
    // Defines a global error handler for any errors that occur from GET requests made using react-query:
    // useQuery, useInfiniteQuery, ...
    // TODO: Look at global handling here later on.
    // onError: (error, query) => {
    //   const messageTitle = query?.meta?.errorTitle || GenericTitle;
    //   const messageText =
    //     error?.response?.data?.error?.message || error?.message || query?.meta?.errorMessage || GenericText;
    //   if (messageText === "Request failed with status code 401") return;
    //   if (query?.meta?.hideErrorMessage) return;
    //   // TODO: Putting this as warn to distinguish thrown by request function vs this error handler while adding query. Ideally, want to just use this handler only...
    //   notification.warn({
    //     message: messageTitle,
    //     description: messageText,
    //   });
    // },
  }),
  // Defines a global error handler for any errors that occur from PUT, POST, DELETE requests made using react-query:
  // useMutation, ...
  mutationCache: new MutationCache({
    // TODO: Look at global handling here later on.
    // onError: (error, variables, context, mutation) => {
    //   const messageTitle = mutation?.meta?.errorTitle || GenericTitle;
    //   const messageText =
    //     error?.response?.data?.error?.message || error?.message || mutation?.meta?.errorMessage || GenericText;
    //   if (messageText === "Request failed with status code 401") return;
    //   if (mutation?.meta?.hideErrorMessage) return;
    //   // TODO: Putting this as warn to distinguish thrown by request function vs this error handler while adding query. Ideally, want to just use this handler only...
    //   notification.warn({
    //     message: messageTitle,
    //     description: messageText,
    //   });
    // },
  }),
});

export default queryClient;
